<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const toastMessages = computed(() => store.getters['toaster/toastMessages']);

const closeToast = () => {
  toastMessages.value.shift();
};
</script>

<template>
  <div class="toasts">
    <TransitionGroup name="toast-fade">
      <div
        v-for="toast in toastMessages"
        :key="toast.id"
        class="toast"
        :class="[toast?.type]"
        @click="closeToast(toast?.id)"
      >
        <span>{{ toast?.msg }}</span>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.toasts {
  position: fixed;
  left: 0;
  right: 0;
  top: 3.1rem;
  z-index: 1000;
  width: 30rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: auto;

  .toast {
    color: white;
    background: colors.$green-color;
    border: solid 1px colors.$green-color;
    border-radius: 5px;
    padding: 16px;
    font-family: Lato, 'Montserrat', Arial, sans-serif;
    transition: all 200ms ease-in-out;
    cursor: pointer;

    &.alert {
      background-color: colors.$red-color;
      border: colors.$red-color;
    }

    &.warning {
      background-color: #ffcd38;
      border: #ffcd38;
      color: #3f3f3f;
    }
  }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.5s;
  transform: translateY(0);
}

.toast-fade-enter-from {
  transform: translateY(-1rem);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(1rem);
}
</style>
